import axios from 'axios';
import { toast } from 'sonner';

export const ouvrirPdf = async (url, headers, nom = 'document.pdf') => {
  const fen = window.open('', '_blank');
  try {
    const r = await axios.get(url, { headers, responseType: 'blob' });
    const lien = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (fen) fen.location.href = lien;
    else Object.assign(document.createElement('a'), { href: lien, download: nom }).click();
    setTimeout(() => URL.revokeObjectURL(lien), 60000);
  } catch (e) {
    if (fen) fen.close();
    let msg = 'Échéancier indisponible';
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (_) { /* corps non JSON */ }
    toast.error(msg);
  }
};
